import { createContext } from "react";
import { IContext } from "./auto-table-row-provider.types";

export const defaultContext: IContext<any> = { row: {} };
export const AutoTableRowContext = createContext<IContext<any> | undefined>(defaultContext);
